import * as React from "react";
import { styled } from "@mui/material";
import {
  MobileView,
  SingleViewPerLayoutBreakPoint,
} from "../../../util/aKaunGeneralUtil";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

//region [[ Styles ]]

const MobileHorizontalScrollMenuView = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  position: "relative", // So the Faders will get it's dimensions
  justifyContent: "center",
  [theme.breakpoints.down(MobileView)]: {
    height: "34px",
    overflow: "hidden",
    margin: "0 -17px",
    marginBottom: theme.spacing(0.5),
  },
}));

const HorizontalScrollContainer = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  flexWrap: "wrap",
  marginBottom: "15px",
  fontSize: "12px",
  alignItems: "center",
  [theme.breakpoints.down(MobileView)]: {
    overflow: "hidden",
    overflowX: "auto",
    marginBottom: "0px",
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
    padding: "0 17px",
  },
}));

const Fader = styled("i")(({ theme }) => ({
  position: "absolute",
  opacity: 1,
  width: "16px",
  zIndex: 1,
  height: "100%",
  [theme.breakpoints.up(SingleViewPerLayoutBreakPoint)]: {
    display: "none",
  },
}));

const LeftFade = styled(Fader)(({ to }: { to?: string }) => ({
  left: "-1px",
  background: `linear-gradient(to left, #ffffff00, ${to ||
    KahunColorMap.Background})`,
}));

const RightFade = styled(Fader)(({ to }: { to?: string }) => ({
  right: "-1px",
  background: `linear-gradient(to right, #ffffff00, ${to ||
    KahunColorMap.Background})`,
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface MobileHorizontalScrollMenuProps {
  className?: string;
  children?: React.ReactElement<any> | React.ReactElement[];
  fadeToColor?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

/***
 * This components creates a menu of items that wraps in desktop,
 * but acts as a single line in mobile
 * @param props
 * @constructor
 */
export const MobileHorizontalScrollMenu = ({
  ...props
}: MobileHorizontalScrollMenuProps) => {
  return (
    <MobileHorizontalScrollMenuView className={props.className}>
      <LeftFade to={props.fadeToColor} />
      <HorizontalScrollContainer className={"scroll-menu-container"}>
        {props.children}
      </HorizontalScrollContainer>
      <RightFade to={props.fadeToColor} />
    </MobileHorizontalScrollMenuView>
  );
};
